module.exports = __webpack_public_path__ + "static/media/dip.e68f1d66.png";